/**
 * O que o módulo 08 ainda não decidiu — e a tela `/combustivel` mostra à
 * sessão de suporte da plataforma. Quem lança diesel não vê: é pendência do
 * projeto, escrita com a numeração interna de módulo (p.22 do manual).
 *
 * ## Por que isto não é mais fixture
 *
 * Esta lista morava em `src/fixtures/combustivel.ts`, ao lado dos tanques e
 * dos abastecimentos inventados. O lugar estava errado desde sempre: fixture é
 * **dado falso apresentado como se fosse real**, e por isso toda tela que a
 * consumia era obrigada a exibir a faixa de demonstração. Isto aqui é o
 * contrário — é o registro honesto de uma pergunta que ninguém respondeu, e
 * ele continua verdadeiro com o banco cheio.
 *
 * Quando a fixture foi aposentada, estas quatro linhas precisavam ir para
 * algum lugar. Foram para o módulo a que pertencem.
 *
 * ## O que saiu da lista, e por quê
 *
 * **"Ícone de combustível".** Estava aqui como decisão em aberto e não estava
 * mais: o dono decidiu `fuel` em 19/09/2026, e a skill `style` registra a
 * entrada. Uma pendência resolvida que continua na tela ensina a pessoa a não
 * ler a lista.
 *
 * **"Faixa de consumo por modelo".** Mudou de forma em vez de sair. A faixa
 * deixou de ser número inventado — ela agora é cadastro, em
 * `ativos.configuracao`. O que continua em aberto é de onde vem o VALOR:
 * ficha do fabricante ou histórico da própria frota.
 */
export const DECISOES_EM_ABERTO: readonly string[] = [
  'Custeio do diesel: rateio por obra, por equipamento ou por frente de serviço.',
  'Tanque próprio no pátio: controle de estoque no módulo 07, ou só os lançamentos do tanque que existem aqui.',
  'Faixa de consumo por configuração: ela já é cadastro, e falta decidir se o valor vem da ficha do fabricante ou do histórico da frota.',
  'Conciliação entre o litro do tanque e o litro do estoque: são duas contagens da mesma substância, e a regra entre elas é do dono.',
];
